import { ABProvider as InsifyABProvider } from '@insify/funnel-components';
import { ensureDeviceId } from '@insify/ui-utils';

import { isLocalDev } from '../../util/env';

import type { EnvType } from '@insify/funnel-components';

type Props = {
  children: React.ReactNode;
  env: EnvType;
};

export const ABProvider: React.FC<Props> = ({ children, env }) => {
  const deviceId = ensureDeviceId(isLocalDev ? undefined : '.insify.fr');
  return (
    <InsifyABProvider deviceId={deviceId} env={env} application='FR_PNC'>
      {children}
    </InsifyABProvider>
  );
};
